export const version = {
    appVersion: '2.9.1',
    buildDate: '2025-11-27 17:18:2'
}
